export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';
export const ADD_ORGANIZATION = 'ADD_ORGANIZATION';
export const SET_ORGANIZATION_LOADING = 'SET_ORGANIZATION_LOADING';
export const SET_ORGANIZATION_SAVING = 'SET_ORGANIZATION_SAVING';
export const SET_ORGANIZATION_CREATE_MODAL = 'SET_ORGANIZATION_CREATE_MODAL';
export const SET_NEW_ORGANIZATION = 'SET_NEW_ORGANIZATION';
